module.exports = __webpack_public_path__ + "static/media/sketches-by-lucastswick-4.e8fc5bd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sketches/sketches-by-lucastswick-4.jpg
// module id = 4390
// module chunks = 14